import { Card, Box, Text, Heading, Avatar, TrackScrolledIntoView } from '@homebotapp/hb-react-component-catalog'
import { useIntl, defineMessages } from 'react-intl'
import { useSelector } from 'react-redux'
import { HOMEOWNER_DIGEST_CUSTOM_MODULE } from '../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'
import {
  selectCustomModules,
  selectCompanyLogo,
  selectCustomerPhotoUri,
  selectCompanyName
} from '../../../store/selectors/customerProfile'
import { LeavingHomebotCtaButton } from '../../shared/LeavingHomebotCta/LeavingHomebotCtaButton'
import QuestionSingle from '../../homeowners/Questions/Single'
import { CUSTOMER_MESSAGES } from '../../../constants/customerMessages'
import { CUSTOM_MODULE } from '../../../constants/document_ids'

const MSG = defineMessages({
  learnMore: {
    id: 'OwnCustomModule.learnMore',
    defaultMessage: 'Learn more'
  },
  corporationRecommends: {
    id: 'OwnCustomModule.corporationRecommends',
    defaultMessage: '{corporationName} recommends you check out their offering.'
  },
  byContinuing: {
    id: 'OwnCustomModule.byContinuing',
    defaultMessage: "By continuing, you'll go to their site in a new tab."
  }
})

export const OwnCustomModule = () => {
  const intl = useIntl()
  const corporationName = useSelector(selectCompanyName)
  const customModules = useSelector(selectCustomModules)
  const companyLogo = useSelector(selectCompanyLogo)
  const customerPhoto = useSelector(selectCustomerPhotoUri)

  const ownCustomModule = customModules?.find((module: any) => module.moduleType === 'own')

  if (!ownCustomModule) return null

  const renderModalBody = () => {
    return (
      <>
        <Text mb={4}>
          {intl.formatMessage(MSG.corporationRecommends, {
            corporationName: corporationName
          })}
        </Text>
        <Text mb={6}>{intl.formatMessage(MSG.byContinuing)}</Text>
      </>
    )
  }

  return (
    <TrackScrolledIntoView
      tracking={{
        guid: 'gssFEWNy0TO4Q3aoEWFvlP',
        ui_context: HOMEOWNER_DIGEST_CUSTOM_MODULE,
        descriptor: 'Homeowner Digest Custom Module'
      }}
    >
      <Card
        borderTopWidth={30}
        id={CUSTOM_MODULE}
        borderTopColor={'brand.600'}
        alignItems={'center'}
        size='lg'
        data-qa='CustomModuleCard'
        scrollMarginTop='var(--digest-module-scroll-margin-top)'
      >
        <Avatar height={75} width={75} mt={-5} mb={15} src={companyLogo ?? customerPhoto} />
        <Heading as='h3' fontWeight='light' mb={15}>
          {ownCustomModule.title}
        </Heading>
        <Text mx={20} mb={15} size={'sm'} fontWeight={'light'} align={'center'}>
          {ownCustomModule.description}
        </Text>
        {ownCustomModule.uri ? (
          <Box mb={5}>
            <LeavingHomebotCtaButton
              ctaButtonSize='md'
              ctaButtonVariant='ghost'
              ctaButtonColorScheme='primary'
              ctaLinkUrl={ownCustomModule.uri}
              renderModalBody={renderModalBody}
              tracking={{
                guid: 'grewgr3tg7QfwenNSt5y32yZYo',
                ui_context: HOMEOWNER_DIGEST_CUSTOM_MODULE,
                descriptor: 'Cta button clicked'
              }}
            >
              {intl.formatMessage(MSG.learnMore)}
            </LeavingHomebotCtaButton>
          </Box>
        ) : (
          <Box bgColor={'card-bg-layer-3'} width={'100%'} p={5} borderBottomRadius={'var(--card-radius)'}>
            <QuestionSingle
              disableCospo
              topic={CUSTOMER_MESSAGES.HOMEOWNER_CUSTOM_MODULE.topic}
              topicKey={CUSTOMER_MESSAGES.HOMEOWNER_CUSTOM_MODULE.topicKey}
              placeholder={CUSTOMER_MESSAGES.HOMEOWNER_CUSTOM_MODULE.message}
            />
          </Box>
        )}
      </Card>
    </TrackScrolledIntoView>
  )
}
